import React, { useEffect, useState } from "react";
import Calendar from "../../../images/calendar.png";
import Verify from "../../../images/verify.png";
import Teamwork from "../../../images/teamwork.png";
import Transaction from "../../../images/transaction.png";
import Time from "../../../images/time.png";
import Live from "../../../images/live.png";
import Graph from "../../../images/image_2024_12_23T05_14_29_073Z.png";
import Graph1 from "../../../images/image_2024_12_23T05_49_06_072Z.png";
import { dashboardData } from "../../../API/Users";
import MyChart from "./DashboradGraph";
const Dashboard = () => {
  const [dashboardList, setDashboardList] = useState([]);
  const checkRole = JSON.parse(localStorage.getItem("userDetail"));
  const fecthDashboardData = async () => {
    const data = await dashboardData();
    setDashboardList(data?.data);
  };
  useEffect(() => {
    fecthDashboardData();
  }, []);
  return (
    <div class="profile-main">
      <div class="event">
        <div class="event_list">
          <h1 class="font-21">Dashboard</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-12 mt-3">
          <div class="no_of_events">
            <div class="register">
              <img src={Calendar} />
            </div>
            <div class="register">
              <h2>{dashboardList?.event}</h2>
              <p class="font-12">No. of Events</p>
            </div>
          </div>
        </div>
        {checkRole?.role_id !== 1 ? (
          ""
        ) : (
          <div class="col-md-4 col-12 mt-3">
            <div class="no_of_events">
              <div class="register">
                <img src={Verify} />
              </div>
              <div class="register">
                <h2>{dashboardList?.user}</h2>
                <p class="font-12">No. of Users Registered</p>
              </div>
            </div>
          </div>
        )}
        {checkRole?.role_id !== 1 ? (
          ""
        ) : (
          <div class="col-md-4 col-12 mt-3">
            <div class="no_of_events">
              <div class="register">
                <img src={Teamwork} />
              </div>
              <div class="register">
                <h2>{dashboardList?.staff}</h2>
                <p class="font-12">No. of Staff Member</p>
              </div>
            </div>
          </div>
        )}
        {checkRole?.role_id !== 1 ? (
          ""
        ) : (
          <div class="col-md-4 col-12 mt-3">
            <div class="no_of_events">
              <div class="register">
                <img src={Transaction} />
              </div>
              <div class="register">
                <h2>{dashboardList?.transaction}</h2>
                <p class="font-12">Total Transactions</p>
              </div>
            </div>
          </div>
        )}

        <div class="col-md-4 col-12 mt-3">
          <div class="no_of_events">
            <div class="register">
              <img src={Time} />
            </div>
            <div class="register">
              <h2>{dashboardList?.schedule}</h2>
              <p class="font-12">Total Schedule Added</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-12 mt-3">
          <div class="no_of_events">
            <div class="register">
              <img src={Live} />
            </div>
            <div class="register">
              <h2>{dashboardList?.live}</h2>
              <p class="font-12">No. of Live Events</p>
            </div>
          </div>
        </div>
      </div>

      {/* <div class="row mt-4">
        <div class="col-md-8 col-12">
          <div class="revenue_updates">
            <div class="overview">
              <div class="point">
                <h4 class="font-18">Revenue updates</h4>
                <p>Overview of Profit</p>
              </div>
              <div class="point">
                <input type="date" class="form-control" />
              </div>
            </div>

            <div class="spike_admin">
              <div class="modernize">
                <p class="font-12">Modernize</p>
              </div>
              <div class="modernize admin">
                <p class="font-12">Spike Admin</p>
              </div>
            </div>
            <div class="modernize_image">
              <img src={Graph} alt="" />
            </div>
          </div>
        </div>
        <div class="col-md-4 col-12">
          <div class="revenue_updates">
            <div class="overview">
              <div class="point">
                <h4 class="font-18">Total profit</h4>
                <p>Overview of Profit</p>
              </div>
              <div class="point">
                <div class="dropdown">
                  <div
                    class=""
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.7218 19.275C12.3051 19.275 11.9511 19.129 11.6598 18.837C11.3678 18.5457 11.2218 18.1917 11.2218 17.775C11.2218 17.3583 11.3678 17.004 11.6598 16.712C11.9511 16.4207 12.3051 16.275 12.7218 16.275C13.1385 16.275 13.4925 16.4207 13.7838 16.712C14.0758 17.004 14.2218 17.3583 14.2218 17.775C14.2218 18.1917 14.0758 18.5457 13.7838 18.837C13.4925 19.129 13.1385 19.275 12.7218 19.275ZM12.7218 13.5C12.3051 13.5 11.9511 13.354 11.6598 13.062C11.3678 12.7707 11.2218 12.4167 11.2218 12C11.2218 11.5833 11.3678 11.2293 11.6598 10.938C11.9511 10.646 12.3051 10.5 12.7218 10.5C13.1385 10.5 13.4925 10.646 13.7838 10.938C14.0758 11.2293 14.2218 11.5833 14.2218 12C14.2218 12.4167 14.0758 12.7707 13.7838 13.062C13.4925 13.354 13.1385 13.5 12.7218 13.5ZM12.7218 7.725C12.3051 7.725 11.9511 7.579 11.6598 7.287C11.3678 6.99567 11.2218 6.64167 11.2218 6.225C11.2218 5.80833 11.3678 5.454 11.6598 5.162C11.9511 4.87067 12.3051 4.725 12.7218 4.725C13.1385 4.725 13.4925 4.87067 13.7838 5.162C14.0758 5.454 14.2218 5.80833 14.2218 6.225C14.2218 6.64167 14.0758 6.99567 13.7838 7.287C13.4925 7.579 13.1385 7.725 12.7218 7.725Z"
                        fill="#7C8FAC"
                      />
                    </svg>
                  </div>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a class="dropdown-item" href="#">
                        Action
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#">
                        Another action
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#">
                        Something else here
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="earnings">
              <div class="total_profit">
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.85583 20.5649C6.40583 20.5649 6.0225 20.4066 5.70583 20.0899C5.38917 19.7733 5.23083 19.3899 5.23083 18.9399C5.23083 18.4899 5.38917 18.1066 5.70583 17.7899C6.0225 17.4733 6.40583 17.3149 6.85583 17.3149C7.30584 17.3149 7.68917 17.4733 8.00584 17.7899C8.3225 18.1066 8.48083 18.4899 8.48083 18.9399C8.48083 19.3899 8.3225 19.7733 8.00584 20.0899C7.68917 20.4066 7.30584 20.5649 6.85583 20.5649ZM12.8558 20.5649C12.4058 20.5649 12.0225 20.4066 11.7058 20.0899C11.3892 19.7733 11.2308 19.3899 11.2308 18.9399C11.2308 18.4899 11.3892 18.1066 11.7058 17.7899C12.0225 17.4733 12.4058 17.3149 12.8558 17.3149C13.3058 17.3149 13.6892 17.4733 14.0058 17.7899C14.3225 18.1066 14.4808 18.4899 14.4808 18.9399C14.4808 19.3899 14.3225 19.7733 14.0058 20.0899C13.6892 20.4066 13.3058 20.5649 12.8558 20.5649ZM18.8558 20.5649C18.4058 20.5649 18.0225 20.4066 17.7058 20.0899C17.3892 19.7733 17.2308 19.3899 17.2308 18.9399C17.2308 18.4899 17.3892 18.1066 17.7058 17.7899C18.0225 17.4733 18.4058 17.3149 18.8558 17.3149C19.3058 17.3149 19.6892 17.4733 20.0058 17.7899C20.3225 18.1066 20.4808 18.4899 20.4808 18.9399C20.4808 19.3899 20.3225 19.7733 20.0058 20.0899C19.6892 20.4066 19.3058 20.5649 18.8558 20.5649ZM6.85583 14.5649C6.40583 14.5649 6.0225 14.4066 5.70583 14.0899C5.38917 13.7733 5.23083 13.3899 5.23083 12.9399C5.23083 12.4899 5.38917 12.1066 5.70583 11.7899C6.0225 11.4733 6.40583 11.3149 6.85583 11.3149C7.30584 11.3149 7.68917 11.4733 8.00584 11.7899C8.3225 12.1066 8.48083 12.4899 8.48083 12.9399C8.48083 13.3899 8.3225 13.7733 8.00584 14.0899C7.68917 14.4066 7.30584 14.5649 6.85583 14.5649ZM12.8558 14.5649C12.4058 14.5649 12.0225 14.4066 11.7058 14.0899C11.3892 13.7733 11.2308 13.3899 11.2308 12.9399C11.2308 12.4899 11.3892 12.1066 11.7058 11.7899C12.0225 11.4733 12.4058 11.3149 12.8558 11.3149C13.3058 11.3149 13.6892 11.4733 14.0058 11.7899C14.3225 12.1066 14.4808 12.4899 14.4808 12.9399C14.4808 13.3899 14.3225 13.7733 14.0058 14.0899C13.6892 14.4066 13.3058 14.5649 12.8558 14.5649ZM18.8558 14.5649C18.4058 14.5649 18.0225 14.4066 17.7058 14.0899C17.3892 13.7733 17.2308 13.3899 17.2308 12.9399C17.2308 12.4899 17.3892 12.1066 17.7058 11.7899C18.0225 11.4733 18.4058 11.3149 18.8558 11.3149C19.3058 11.3149 19.6892 11.4733 20.0058 11.7899C20.3225 12.1066 20.4808 12.4899 20.4808 12.9399C20.4808 13.3899 20.3225 13.7733 20.0058 14.0899C19.6892 14.4066 19.3058 14.5649 18.8558 14.5649ZM6.85583 8.56494C6.40583 8.56494 6.0225 8.40661 5.70583 8.08994C5.38917 7.77327 5.23083 7.38994 5.23083 6.93994C5.23083 6.48994 5.38917 6.10661 5.70583 5.78994C6.0225 5.47327 6.40583 5.31494 6.85583 5.31494C7.30584 5.31494 7.68917 5.47327 8.00584 5.78994C8.3225 6.10661 8.48083 6.48994 8.48083 6.93994C8.48083 7.38994 8.3225 7.77327 8.00584 8.08994C7.68917 8.40661 7.30584 8.56494 6.85583 8.56494ZM12.8558 8.56494C12.4058 8.56494 12.0225 8.40661 11.7058 8.08994C11.3892 7.77327 11.2308 7.38994 11.2308 6.93994C11.2308 6.48994 11.3892 6.10661 11.7058 5.78994C12.0225 5.47327 12.4058 5.31494 12.8558 5.31494C13.3058 5.31494 13.6892 5.47327 14.0058 5.78994C14.3225 6.10661 14.4808 6.48994 14.4808 6.93994C14.4808 7.38994 14.3225 7.77327 14.0058 8.08994C13.6892 8.40661 13.3058 8.56494 12.8558 8.56494ZM18.8558 8.56494C18.4058 8.56494 18.0225 8.40661 17.7058 8.08994C17.3892 7.77327 17.2308 7.38994 17.2308 6.93994C17.2308 6.48994 17.3892 6.10661 17.7058 5.78994C18.0225 5.47327 18.4058 5.31494 18.8558 5.31494C19.3058 5.31494 19.6892 5.47327 20.0058 5.78994C20.3225 6.10661 20.4808 6.48994 20.4808 6.93994C20.4808 7.38994 20.3225 7.77327 20.0058 8.08994C19.6892 8.40661 19.3058 8.56494 18.8558 8.56494Z"
                    fill="#5D87FF"
                  />
                </svg>
              </div>
              <div class="earnings_text">
                <h4 class="font-16">$63,489.50</h4>
                <p class="font-12">Total Earnings</p>
              </div>
            </div>
            <div class="modernize_image">
              <img src={Graph1} alt="" />
            </div>
          </div>
        </div>
      </div> */}
      <MyChart role={checkRole} dashboardList={dashboardList} />
      {/* <div class="copyright text-center">
        <p>copyright, 2024 | all rights reserved, celebrationtalent.com</p>
      </div> */}
    </div>
  );
};
export default Dashboard;
